export const Logo = ({ compact = false }) => (
  <span className="inline-flex items-center gap-2.5 select-none">
    <svg viewBox="0 0 32 32" className="h-8 w-8 shrink-0" aria-hidden="true">
      <defs>
        <linearGradient id="gmark-nav" x1="0" y1="0" x2="1" y2="1">
          <stop offset="0" stopColor="#818CF8" />
          <stop offset="1" stopColor="#8B5CF6" />
        </linearGradient>
      </defs>
      <rect x="1" y="1" width="30" height="30" rx="9" fill="url(#gmark-nav)" />
      <path
        d="M22.5 12.6 A 7.2 7.2 0 1 0 23.2 16.6 L 16 16.6"
        fill="none"
        stroke="#0B0B1A"
        strokeWidth="3.2"
        strokeLinecap="round"
      />
    </svg>
    {!compact && (
      <span className="font-display font-bold tracking-tight text-lg text-white">
        Giul<span className="text-viol-soft">IA</span>Teck
      </span>
    )}
  </span>
);

export default Logo;
